// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2071r","ranges":"BmiRanges_ranges__mzevD"};